<template>
  <div class="mb-10 mt-12 relative">
    <div>
      <select class="tt-select" v-model="fontFace">
        <option value="Default">Default</option>
        <option value="Specific domains">Specific domains</option>
        <option value="Path only">Path only</option>
      </select>

      <div v-if="fontFace === 'Specific domains'" class="ml-4">
        <ul v-if="onboarding.properties && onboarding.properties.domains">
          <li  v-for="(value, key) in onboarding.properties.domains.subdomains" class="mb-2 font-semibold flex items-center justify-between">
            {{ key }}
            <vs-button class="ml-4" @click="openModal(key)">Add substitution</vs-button>
          </li>
        </ul>
        <div class="flex items-center">
          <input v-model="newDomain" type="text" placeholder="Add new URL" class="border p-2 rounded w-full mr-2" />
          <vs-button @click="addDomain">Add domain</vs-button>
        </div>
      </div>
     </div>

    <div class="absolute bottom-1 left-1">
      <vs-button @click="SaveChanges">Save</vs-button>
    </div>

    <!-- Modal -->
    <div v-if="isModalOpen"  class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div class="bg-white p-6 rounded-lg w-96">
        <h2 class="text-lg font-bold mb-4">Manage URLs for {{ selectedDomain }}</h2>

        <ul class="mb-4">
          <li v-for="(url, index) in registeredUrls" :key="index" class="mb-2">
            {{ url }}
          </li>
        </ul>

        <div class="flex items-center">
          <input v-model="newUrl" type="text" placeholder="Add new URL" class="border p-2 rounded w-full mr-2" />
          <vs-button @click="addUrl">Add subdomain</vs-button>
        </div>

        <div class="flex justify-end mt-4">
          <vs-button @click="closeModal">Close</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  export default {
    data() {
      return {
        fontFace: 'Default',
        isModalOpen: false,
        selectedDomain: '',
        newProperties: {
          domains: {
            default: "",
            pathOnly: "",
            activeDomainTrigger: 0,
            subdomains: {

            }
          }
        },
        newDomain:'',
        newUrl: '',
      };
    },
    props: ["onboarding"],
    mounted() {
      this.setProperties();
    },
    methods: {
      openModal(domain) {
        this.selectedDomain = domain;
        this.registeredUrls = this.onboarding.properties.domains.subdomains[domain] // Load the URLs for the selected domain
        this.isModalOpen = true;
      },
      closeModal() {
        this.isModalOpen = false;
      },
      addDomain() {
        if (this.newDomain.trim() !== '') {
          var domain = this.newDomain
          if (this.onboarding.properties != null && this.onboarding.properties.domains != "") {
            this.$set(this.onboarding.properties.domains.subdomains, this.newDomain, []);
          }

          else {
            this.onboarding.properties = this.newProperties
            this.$set(this.onboarding.properties.domains.subdomains, this.newDomain, []);
            this.newDomain = '';
          }
        }
      },

      addUrl() {
        if (this.newUrl.trim() !== '') {
          this.onboarding.properties.domains.subdomains[this.selectedDomain].push(this.newUrl.trim());
          this.newUrl = '';
        }
      },

      SaveChanges() {
        var instance = this;
        const query = `
  mutation UpdateOnboarding($onboarding: OnboardingInput!) {
    updateMainFields(
      entity: $onboarding
    ) {
      id,
      name
      description
      rawContent,
      properties
    }
  }
`;
        instance.onboarding.properties.domains.activeDomainTrigger = this.fontFace
        instance.onboarding.properties = JSON.stringify(instance.onboarding.properties)
        const variables = {
          onboarding: instance.onboarding
      };
      

      const req = {
        query,
        variables
      };

      TCVelikClient.PostRelative("/api/graphql", req, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      }).then(function (response) {
        if (response && response.data && response.data.data) {
          instance.onboarding.properties = response.data.data.updateMainFields.properties;
          instance.setProperties();
          instance.$vs.notify({
            title: "Successfully updated properties!",
            color: "success",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        }
        else if (response && response.data && response.data.errors) {
          alert('There were some errors saving :(');
        }
      });
      },
      setProperties() {
        try {
          this.onboarding.properties = JSON.parse(this.onboarding.properties)
          this.fontFace = this.onboarding.properties.domains.activeDomainTrigger
        }
        catch {
          this.fontFace = this.onboarding.properties.domains.activeDomainTrigger
        }
        
      }
      
     
      
    }
  };
</script>

<style scoped>
  .tt-select {
    width: 152px;
    height: 32px;
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
    text-align: center;
    padding: 3px;
    border-radius: 5px;
    border: 1px solid grey;
    background: #fff;
    color: #000;
    font-weight: 700;
    cursor: pointer;
    margin-right: 3px;
    min-width: 33px;
    height: 33px !important;
    margin-top: 10px
  }
</style>
